import { AlgorithmSourcesValidFormDataSchema } from './AlgorithmSourcesValidFormDataSchema';
import { AlgorithmSourceValidFormDataType } from './types';

export const AlgorithmSourcesMutationDtoSchema =
  AlgorithmSourcesValidFormDataSchema.transform(({ sources, ...rest }) => {
    return {
      ...rest,
      sources: sources.map(
        ({
          id,
          numberOfPreviousPeriod,
          sourceId,
          ...source
        }: AlgorithmSourceValidFormDataType) => {
          const sourceValues = sourceId?.split('-') || [];
          return {
            ...source,
            id: id !== -1 ? id : null,
            numberOfPreviousPeriod: numberOfPreviousPeriod
              ? numberOfPreviousPeriod
              : 0,
            dataSourceId:
              sourceValues[0] === 'ds' ? Number(sourceValues[1]) : undefined,
            dataObjectDescriptionId:
              sourceValues[0] === 'dod' ? Number(sourceValues[1]) : undefined,
          };
        }
      ),
    };
  });
